import React, {Component} from 'react';
import '../styles/client-member-list.css';
import PropTypes from 'prop-types';
import AvatarImage from 'assets/images/profile.png';
import AddAgentIcon from '../../../../../assets/images/add-agent.svg';
import {handleElementSelect, handleSelectAll} from '../../../../../utils/ComponentUtilFunctions';
import {filterElements, filterInputStyle} from '../../../../../utils/General';
import Translate from '../../../../../components/Translate';
import TranslateProperty from "../../../../../components/TranslateProperty";

const searchBackgroundColorStyle = {
    backgroundColor: 'transient',
};

class NotConnectedMembers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nameFilter: '',
            selectedIds: [],
        };
        this.handleSelectAll = handleSelectAll(this.getFilteredMembers, this);
        this.handleMemberSelect = handleElementSelect.bind(this);
    }

    getFilteredMembers = () => {
        const {notConnectedMembers} = this.props;
        const {selectedIds} = this.state;

        return filterElements(notConnectedMembers, '', member => selectedIds.includes(member.id));
    };

    filterByName = () => {
        const {nameFilter} = this.state;

        return this.getFilteredMembers().filter(op => {
            return (op.firstName + " " + op.lastName).toLowerCase().includes(nameFilter.toLowerCase())
        });
    }


    handleNameFilterChange = (text) => {
        this.setState({
            nameFilter: text,
        });
    };

    addSelectedMembers = () => {
        const {notConnectedMembers} = this.props;
        const {selectedIds} = this.state;
        const selectedMembers = notConnectedMembers.filter(member => selectedIds.includes(member.id));
        this.addMembersToClient(selectedMembers);
    };

    addMembersToClient = (members) => {
        const {addMembersToClient, client} = this.props;
        addMembersToClient(members, client).then(() => {
            const {selectedIds} = this.state;
            this.setState({
                selectedIds: selectedIds.filter(id => members.findIndex(member => member.id === id) === -1),
            });
        });
    };

    render() {
        const {
            nameFilter, selectedIds,
        } = this.state;

        const filteredMembers = this.filterByName();

        return (
            <div style={{padding: '20px'}}>
                <br/>
                <div style={{marginBottom: '20px', display: 'flex', gap: '20px', justifyContent: 'center'}}>
                    <TranslateProperty properties={[{
                        key: 'placeholder',
                        value: 'searchByOperator'
                    }]}>
                        <input
                            type="text"
                            value={nameFilter}
                            onChange={(e) => this.handleNameFilterChange(e.target.value)}
                            style={filterInputStyle}
                        />
                    </TranslateProperty>
                </div>
                <table className="custom-table">
                    <thead>
                    <tr className="table-head">
                        <th>
                            <input
                                type="checkbox"
                                checked={filteredMembers.length === selectedIds.length && filteredMembers.length}
                                onChange={this.handleSelectAll}
                            />
                        </th>

                        <th>
                            <div style={searchBackgroundColorStyle}>
                                <Translate text="operator"/>
                            </div>
                        </th>
                        <th style={{textAlign: "right"}} className="add-header">
                            <button
                                type="button"
                                className="no-style-button"
                                style={{visibility: selectedIds.length > 0 ? 'visible' : 'hidden'}}
                                onClick={this.addSelectedMembers}
                            >
                                <Translate text="add"/>{` (${selectedIds.length})`}
                            </button>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {filteredMembers.map(member => (
                        <tr key={member.id} className="body-row">
                            <td className="checkbox-header">
                                <input
                                    type="checkbox"
                                    checked={selectedIds.includes(member.id)}
                                    onChange={this.handleMemberSelect(member.id)}
                                />
                            </td>

                            <td className="user-info">
                                <div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
                                    <img src={member.thumbUrl || AvatarImage} alt="Avatar" className="avatar"/>
                                    <div style={{display: 'flex', flexDirection: 'column'}}>
                                        <span className="name-text">{`${member.firstName} ${member.lastName}`}</span>
                                        <span className="email-text">{member.email}</span>
                                    </div>
                                </div>
                            </td>

                            <td style={{textAlign: 'right'}} className="add-cell">
                                <img
                                    className="remove-image"
                                    src={AddAgentIcon}
                                    onClick={() => {
                                        this.addMembersToClient([member]);
                                    }}
                                    role="presentation"
                                    alt="not found"
                                />
                            </td>
                        </tr>
                    ))
                    }
                    </tbody>
                </table>
            </div>
        );
    }
}

NotConnectedMembers.propTypes = {
    notConnectedMembers: PropTypes.array.isRequired,
    client: PropTypes.object.isRequired,
    addMembersToClient: PropTypes.func.isRequired,
};
export default NotConnectedMembers;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/NotConnectedMembers.jsx